// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateAssociationBindingAdmin, ValidateCreateAssociationBindingAdminSchema } from 'api/gen/ValidateCreateAssociationBindingAdmin';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateAssociationBindingAdmin, ValidateUpdateAssociationBindingAdminSchema } from 'api/gen/ValidateUpdateAssociationBindingAdmin';

export const ValidateAssociationBindingAdminSchema = t.union([ValidateCreateAssociationBindingAdminSchema, ValidateUpdateAssociationBindingAdminSchema]);

export type ValidateAssociationBindingAdmin = t.TypeOf<typeof ValidateAssociationBindingAdminSchema>;
